/* Purlbrook motion: unhurried scroll reveals + quiet header shadow.
   Transform/opacity only (no layout jank); fully disabled under
   prefers-reduced-motion (CSS also guards, so this is belt & braces). */
(function () {
  document.documentElement.classList.remove('no-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header shadow once the page starts moving.
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var revealed = function (el) { el.classList.add('is-revealed'); };
  var targets = document.querySelectorAll('[data-reveal]');

  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach(revealed);
    return;
  }

  // Stagger siblings inside a reveal group (capped so deep groups don't lag).
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    group.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      el.style.setProperty('--reveal-delay', Math.min(i * 70, 280) + 'ms');
    });
  });

  // Reviews stay invisible until Judge.me reports a real review count.
  // Their JS sets data-number-of-reviews after hydration; we poll briefly
  // and reveal only when count > 0. Zero reviews = nothing on the page.
  var revealReviews = function () {
    var any = false;
    document.querySelectorAll('.jdgm-widget').forEach(function (w) {
      var el = w.querySelector('[data-number-of-reviews]') ||
               (w.matches('[data-number-of-reviews]') ? w : null);
      var n = el ? parseInt(el.getAttribute('data-number-of-reviews'), 10) : 0;
      if (n > 0) { w.classList.add('has-reviews'); any = true; }
    });
    return any;
  };
  var tries = 0;
  var reviewTimer = setInterval(function () {
    tries += 1;
    if (revealReviews() || tries > 20) { clearInterval(reviewTimer); }
  }, 500);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        revealed(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  targets.forEach(function (el) { observer.observe(el); });

  // Fast scrolls, deep links and bfcache restores can put elements behind the
  // viewport before the observer ever sees them intersect — those would stay
  // faded forever. Anything the viewport has already passed reveals plainly.
  if (window.scrollY > 40) {
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) { revealed(el); }
    });
  }
  var catchingUp = false;
  window.addEventListener('scroll', function () {
    if (catchingUp) { return; }
    catchingUp = true;
    requestAnimationFrame(function () {
      catchingUp = false;
      targets.forEach(function (el) {
        if (!el.classList.contains('is-revealed') &&
            el.getBoundingClientRect().bottom < 0) { revealed(el); }
      });
    });
  }, { passive: true });
})();

/* mobile sticky buy bar: show while the real buy form is off-screen */
(function () {
  var bar = document.querySelector('.sticky-buy');
  var form = document.getElementById('buy-form');
  if (!bar || !form || !('IntersectionObserver' in window)) { return; }

  var io = new IntersectionObserver(function (entries) {
    var formVisible = entries[0].isIntersecting;
    bar.classList.toggle('is-visible', !formVisible);
    bar.setAttribute('aria-hidden', formVisible ? 'true' : 'false');
  }, { threshold: 0 });
  io.observe(form);

  /* keep both price displays in sync with the chosen variant */
  var select = form.querySelector('.variant-select');
  if (select) {
    select.addEventListener('change', function () {
      var text = select.options[select.selectedIndex].textContent;
      var match = text.match(/[$€£][\d,.]+/);
      if (!match) { return; }
      var stickyPrice = bar.querySelector('.sticky-buy-price');
      var pagePrice = document.querySelector('.product-price');
      if (stickyPrice) { stickyPrice.textContent = match[0]; }
      if (pagePrice) { pagePrice.childNodes[0].textContent = match[0] + ' '; }
    });
  }
})();
